// Wishlist functionality - Vanilla JavaScript
;(function () {
	'use strict'

	// Inject CSS to hide HubSpot form immediately (before DOM is fully loaded)
	const style = document.createElement('style')
	style.textContent = '#ui-hfc { display: none !important; }'
	document.head.appendChild(style)

	// Check if wishlist was modified on another page and reload if needed
	if (sessionStorage.getItem('wishlist_modified') && !sessionStorage.getItem('wishlist_reloaded_after_modify')) {
		sessionStorage.setItem('wishlist_reloaded_after_modify', 'true')
		location.reload()
		return
	}
	// Clear the reload flag after successful reload
	sessionStorage.removeItem('wishlist_reloaded_after_modify')
	sessionStorage.removeItem('wishlist_modified')

	function isMobile() {
		var mobile = /iphone|ipod|android|ie|blackberry|fennec/.test(navigator.userAgent.toLowerCase())
		return mobile
	}

	// Parse wishlist cookie
	// Format: "MAT123:::5,MAT456:::10"
	function parseWishlistCookie() {
		const cookieValue = (document.cookie.match(/(?:^|; )pxa_pm_wish_list=([^;]*)/) || [])[1] || ''
		const decodedValue = decodeURIComponent(cookieValue)
		const items = decodedValue ? decodedValue.split(',').filter(item => item.trim() !== '') : []

		const wishlist = {}
		items.forEach(item => {
			if (item.includes(':::')) {
				const [productId, quantity] = item.split(':::')
				wishlist[productId] = parseInt(quantity) || 1
			}
		})

		return wishlist
	}

	// Update wishlist cookie with new quantities
	function updateWishlistCookie(productId, quantity) {
		const wishlist = parseWishlistCookie()

		if (quantity > 0) {
			wishlist[productId] = quantity
		} else {
			delete wishlist[productId]
		}

		// Format cookie: "MAT123:::5,MAT456:::10"
		const cookieItems = Object.entries(wishlist).map(([id, qty]) => `${id}:::${qty}`)
		const cookieValue = encodeURIComponent(cookieItems.join(','))

		// Set cookie (1 year expiration)
		const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString()
		document.cookie = `pxa_pm_wish_list=${cookieValue}; expires=${expires}; path=/`

		return wishlist
	}

	function clearWishlistCookie() {
		const host = window.location.hostname.replace(/:\d+$/, '')
		const domains = ['']

		if (host && host !== 'localhost' && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
			domains.push(host)

			const hostParts = host.split('.')
			if (hostParts.length >= 2) {
				domains.push('.' + hostParts.slice(-2).join('.'))
			}
		}

		const expires = 'Thu, 01 Jan 1970 00:00:00 GMT'
		Array.from(new Set(domains)).forEach(domain => {
			let cookie = `pxa_pm_wish_list=; expires=${expires}; path=/`
			if (domain) {
				cookie += `; domain=${domain}`
			}
			document.cookie = cookie
		})
	}

	// Update wishlist counter from cookie
	function updateWishlistCounterFromCookie() {
		const wishlist = parseWishlistCookie()
		const count = Object.keys(wishlist).length

		// Update ALL meta navigation counters (Desktop + Mobile)
		const counters = document.querySelectorAll('.wishlist-counter')
		counters.forEach(counter => {
			counter.textContent = count
			counter.setAttribute('data-count', count)
			if (count > 0) {
				counter.classList.remove('hidden')
			} else {
				counter.classList.add('hidden')
			}
		})

		// Update page counters
		const pageCounters = document.querySelectorAll('.ui-counter')
		pageCounters.forEach(c => {
			c.textContent = count
		})

		return wishlist
	}

	// Initialize counter on page load
	if (window.location.hash === '#wishlist-success') {
		clearWishlistCookie()
	}
	updateWishlistCounterFromCookie()

	// Replace pipe character in product titles with <br> for better formatting
	const productTitles = document.querySelectorAll('.product-title')
	productTitles.forEach(title => {
		const text = title.textContent
		const newText = text.replace(/\|/g, '<br>')
		title.innerHTML = newText
	})

	document.addEventListener('click', function (e) {
		if (isMobile()) {
			const button = e.target.closest('.lang-btn')
			if (!button) return

			e.preventDefault()

			const target = button.parentNode.nextSibling
			const isVisible = target.style.display === 'block'

			if (isVisible) {
				Object.assign(target.style, {
					opacity: '0',
					visibility: 'hidden',
					display: 'none',
				})
			} else {
				Object.assign(target.style, {
					opacity: '1',
					visibility: 'visible',
					display: 'block',
				})
			}
		}
	})

	// Handle remove from wishlist
	document.addEventListener('click', function (e) {
		const button = e.target.closest('.toggle-wishlist')
		if (!button) return

		e.preventDefault()

		const productId = button.dataset.id
		const url = button.dataset.url

		fetch(url + '&type=7385', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams({
				'tx_stewocom_pdmsproduct[product]': productId,
			}),
		})
			.then(response => response.json())
			.then(data => {
				if (data.success) {
					// Fade out and remove the product item
					const productItem = button.closest('.wishlist-product-item')
					if (productItem) {
						productItem.style.transition = 'opacity 300ms'
						productItem.style.opacity = '0'

						setTimeout(() => {
							productItem.remove()

							// Update counter from cookie (use new format)
							const wishlist = parseWishlistCookie()
							const newCount = Object.keys(wishlist).length

							// Update counters
							const counters = document.querySelectorAll('.ui-counter')
							counters.forEach(counter => {
								counter.textContent = newCount
							})

							// Update meta navigation counter
							const navCounters = document.querySelectorAll('.wishlist-counter')
							navCounters.forEach(counter => {
								counter.textContent = newCount
								counter.setAttribute('data-count', newCount)
								if (newCount === 0) {
									counter.classList.add('hidden')
								}
							})

							// Reload if no products left
							if (newCount === 0) {
								setTimeout(() => {
									location.reload()
								}, 500)
							}
						}, 300)
					}
				}
			})
			.catch(() => {
				// Silent fail - just reload the page
				location.reload()
			})
	})

	// Only check if products are loaded after a delay
	setTimeout(() => {
		const firstCounter = document.querySelector('.ui-counter')
		const expectedCount = firstCounter ? parseInt(firstCounter.textContent) : 0
		const actualCount = document.querySelectorAll('.wishlist-product-item').length

		// Only reload if we expect products but have none, and only once
		if (expectedCount > 0 && actualCount === 0) {
			if (!sessionStorage.getItem('wishlist_reloaded')) {
				sessionStorage.setItem('wishlist_reloaded', 'true')
				location.reload()
			}
		} else if (actualCount > 0) {
			sessionStorage.removeItem('wishlist_reloaded')
		}
	}, 2000)

	// Quantity stepper functionality
	function roundDownToVE(value, ve) {
		return Math.floor(value / ve) * ve
	}

	function validateAndRoundQuantity(input) {
		const ve = parseInt(input.dataset.ve)
		const productId = input.dataset.productId
		let value = parseInt(input.value)

		if (isNaN(value) || value < ve) {
			value = ve
		} else {
			value = roundDownToVE(value, ve)
		}

		input.value = value

		// Update cookie with new quantity
		if (productId) {
			updateWishlistCookie(productId, value)
		}

		return value
	}

	// Handle quantity buttons
	document.addEventListener('click', function (e) {
		// Handle increase buttons
		const increaseBtn = e.target.closest('.quantity-increase')
		if (increaseBtn) {
			const productId = increaseBtn.dataset.productId
			const ve = parseInt(increaseBtn.dataset.ve)
			const input = document.querySelector(`input[data-product-id="${productId}"]`)

			if (input) {
				const currentValue = parseInt(input.value) || ve
				const newValue = currentValue + ve
				input.value = newValue
				updateWishlistCookie(productId, newValue)
			}
			return
		}

		// Handle decrease buttons
		const decreaseBtn = e.target.closest('.quantity-decrease')
		if (decreaseBtn) {
			const productId = decreaseBtn.dataset.productId
			const ve = parseInt(decreaseBtn.dataset.ve)
			const input = document.querySelector(`input[data-product-id="${productId}"]`)

			if (input) {
				const currentValue = parseInt(input.value) || ve
				if (currentValue > ve) {
					const newValue = currentValue - ve
					input.value = newValue
					updateWishlistCookie(productId, newValue)
				}
			}
		}
	})

	// Handle manual input - round DOWN to nearest VE on blur
	document.addEventListener(
		'blur',
		function (e) {
			if (e.target.classList.contains('quantity-input')) {
				validateAndRoundQuantity(e.target)
			}
		},
		true
	)

	// Handle Enter key
	document.addEventListener('keypress', function (e) {
		if (e.target.classList.contains('quantity-input') && e.key === 'Enter') {
			validateAndRoundQuantity(e.target)
		}
	})

	// Handle Arrow Up/Down keys and prevent typing invalid characters
	document.addEventListener('keydown', function (e) {
		if (!e.target.classList.contains('quantity-input')) return

		const ve = parseInt(e.target.dataset.ve)
		const productId = e.target.dataset.productId

		// Handle Arrow Up
		if (e.keyCode === 38) {
			e.preventDefault()
			const currentValue = parseInt(e.target.value) || ve
			const newValue = currentValue + ve
			e.target.value = newValue
			if (productId) {
				updateWishlistCookie(productId, newValue)
			}
			return
		}

		// Handle Arrow Down
		if (e.keyCode === 40) {
			e.preventDefault()
			const currentValue = parseInt(e.target.value) || ve
			if (currentValue > ve) {
				const newValue = currentValue - ve
				e.target.value = newValue
				if (productId) {
					updateWishlistCookie(productId, newValue)
				}
			}
			return
		}

		// Allow: backspace, delete, tab, escape, enter
		if (
			[46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
			// Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
			(e.keyCode === 65 && e.ctrlKey) ||
			(e.keyCode === 67 && e.ctrlKey) ||
			(e.keyCode === 86 && e.ctrlKey) ||
			(e.keyCode === 88 && e.ctrlKey) ||
			// Allow: home, end, left, right
			(e.keyCode >= 35 && e.keyCode <= 37) ||
			e.keyCode === 39
		) {
			return
		}

		// Ensure that it is a number and stop the keypress
		if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
			e.preventDefault()
		}
	})

	// Handle HubSpot form submission - prepare wishlist data as HTML list AND add products to form
	document.addEventListener('submit', function (e) {
		const form = e.target
		console.log('[WISHLIST DEBUG] Form submitted:', form.getAttribute('name'))
		if (form.getAttribute('name') !== 'form') {
			console.log('[WISHLIST DEBUG] Not a HubSpot form, skipping')
			return
		}
		if (form.dataset.stewoManagedSubmit === '1') {
			console.log('[WISHLIST DEBUG] Stewo managed submit active, skipping legacy handler')
			return
		}

		const productForm = document.querySelector('.productRequestForm')
		if (!productForm) {
			console.log('[WISHLIST DEBUG] No productRequestForm found')
			return
		}
		console.log('[WISHLIST DEBUG] Found productRequestForm')

		const toProductText = productForm.dataset.i18nToProduct || 'To product'

		const formData = new FormData(productForm)
		const productsData = []

		// Extract product data from form
		formData.forEach((value, key) => {
			console.log('[WISHLIST DEBUG] FormData key:', key, 'value:', value)
			// Match pattern: tx_stewocom_wishlist[orderProducts][MATERIALNUMMER][FIELD]
			const match = key.match(/^tx_stewocom_wishlist\[orderProducts\]\[(.*?)\]\[(.*?)\]$/)
			if (!match) return

			const [, productSKU, field] = match
			console.log('[WISHLIST DEBUG] Matched product:', productSKU, 'field:', field)

			let product = productsData.find(p => p.sku === productSKU)
			if (!product) {
				product = { sku: productSKU }
				productsData.push(product)
			}

			// Store all field values
			product[field] = value
		})

		console.log('[WISHLIST DEBUG] Total products extracted:', productsData.length, productsData)

		// ADD ALL PRODUCT FIELDS TO HUBSPOT FORM AS HIDDEN INPUTS
		// This ensures the EventListener receives the product data
		formData.forEach((value, key) => {
			if (key.startsWith('tx_stewocom_wishlist[orderProducts]')) {
				// Create hidden input for each product field
				const hiddenInput = document.createElement('input')
				hiddenInput.type = 'hidden'

				// Remove namespace: tx_stewocom_wishlist[orderProducts][...] -> orderProducts[...]
				// EventListener expects orderProducts[...] format in $_POST
				const cleanKey = key.replace('tx_stewocom_wishlist[', '').replace(']', '')
				hiddenInput.name = cleanKey
				hiddenInput.value = value
				form.appendChild(hiddenInput)
			}
		})

		// Helper function to escape HTML, but allow <br> tags
		const esc = s => {
			const str = String(s ?? '')
			// First escape everything
			let escaped = str
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;')
			// Then restore <br> tags
			escaped = escaped.replace(/&lt;br&gt;/gi, '<br>')
			return escaped
		}

		// Generate HTML list
		function toHtmlList(items) {
			const chunks = []
			const date = new Date().toLocaleDateString('de-DE')
			chunks.push(`-----------------------`)
			chunks.push(`<div class="row"><span>Anfragedatum: ${esc(date)}</span></div>`)
			chunks.push('<ul>')

			chunks.push(
				items
					.map(p => {
						const sku = p.sku ?? ''
						const name = p.name ?? ''
						const link = p.link ?? '#'
						const amount = p.amount ?? ''

						const lines = []
						lines.push(`<li><a href="${esc(link)}" title="Zum Produkt">${esc(name)}</a></li>`)
						lines.push(`<li>`)
						lines.push(`  Artikelnummer: ${esc(sku)}`)
						lines.push(`  <ul>`)
						if (amount) lines.push(`    <li>Menge: ${esc(amount)}</li>`)
						lines.push(`  </ul>`)
						lines.push(`</li>`)

						return lines.join('\n')
					})
					.join('\n')
			)

			chunks.push('</ul>')
			return chunks.join('\n')
		}

		// Generate HTML list and populate HubSpot field
		const htmlList = toHtmlList(productsData)
		console.log('[WISHLIST DEBUG] Generated HTML list:', htmlList)

		let descField = document.querySelector('textarea[name="tx_brunnenhubspot_showhubspotforms[anfrageliste_beps]"]')
		console.log('[WISHLIST DEBUG] Found anfrageliste_beps field:', descField ? 'YES' : 'NO')

		// If field doesn't exist, create it as hidden field
		if (!descField) {
			console.log('[WISHLIST DEBUG] Creating hidden anfrageliste_beps field')
			descField = document.createElement('textarea')
			descField.name = 'tx_brunnenhubspot_showhubspotforms[anfrageliste_beps]'
			descField.style.display = 'none'
			form.appendChild(descField)
		}

		descField.value = htmlList
		console.log('[WISHLIST DEBUG] Set anfrageliste_beps field value, length:', htmlList.length)
	})

	// Toggle between wishlist products and request form
	function initFormToggle() {
		const wishlistContainer = document.querySelector('.productRequestForm section')
		const formContainer = document.querySelector('#ui-hfc')
		const requestButtons = document.querySelectorAll('[data-wishlist-form-toggle], a[href="#ui-hfc"], a[href="#c4475"]')

		if (!formContainer || !requestButtons.length) return

		function showRequestForm() {
			formContainer.style.cssText = 'display: block !important; opacity: 0;'
			formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })

			setTimeout(() => {
				formContainer.style.cssText = 'display: block !important; opacity: 1; transition: opacity 300ms;'
			}, 50)
		}

		requestButtons.forEach(requestButton => {
			requestButton.addEventListener('click', function (e) {
				e.preventDefault()
				showRequestForm()
			})
		})

		if (window.location.hash === '#ui-hfc' || window.location.hash === '#c4475') {
			showRequestForm()
		}

		// Optional: Add back button to return to wishlist
		const backButton = formContainer.querySelector('.back-to-wishlist')
		if (backButton) {
			backButton.addEventListener('click', function (e) {
				e.preventDefault()

				// Hide form
				formContainer.style.cssText = 'display: block !important; opacity: 0; transition: opacity 300ms;'

				setTimeout(() => {
					formContainer.style.cssText = 'display: none !important;'

					// Show wishlist
					// wishlistContainer.style.display = 'block'
					// wishlistContainer.style.opacity = '0'

					// Smooth scroll to wishlist
					if (wishlistContainer) {
						wishlistContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
					}

					// Fade in wishlist
					setTimeout(() => {
						if (wishlistContainer) {
							wishlistContainer.style.transition = 'opacity 300ms'
							wishlistContainer.style.opacity = '1'
						}
					}, 50)
				}, 300)
			})
		}
	}

	// Initialize form toggle when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initFormToggle)
	} else {
		initFormToggle()
	}
})()
